import React from "react";
import ModalBasic from "../../component/ModalBasic";

const SendInvoice = (props) => {
    return (
        <ModalBasic
            id="send-invoice-modal"
            modalOpen={props.setSendInvoiceModal}
            setModalOpen={props.setOpenModal}
            title=""
            noCloseIcon={true}
        >
            <div className="text-center pb-2">
                <h1 className="text-xl text-[#000000] font-normal leading-loose p-8 py-4">
                    The invoice of {props.companyName} has ben sent successfully to {props.email}
                </h1>
                <button
                    className="btn btn-blue text-base text-[#fff] font-bold py-2 my-4"
                    onClick={props.onClose}
                >
                    Ok
                </button>
            </div >
        </ModalBasic>
    );
}
export default SendInvoice;